import { Clock, Shield, SlidersHorizontal } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type AgendaSettingsSectionKey = 'geral' | 'horarios' | 'administrativo';

export const DEFAULT_AGENDA_SETTINGS_SECTION: AgendaSettingsSectionKey = 'geral';

export const AGENDA_SETTINGS_SECTIONS: Array<{
    key: AgendaSettingsSectionKey;
    icon: LucideIcon;
    title: string;
    description: string;
    adminOnly?: boolean;
}> = [
    {
        key: 'geral',
        icon: SlidersHorizontal,
        title: 'Geral',
        description: 'Limites de datas, intervalos e regras básicas.',
    },
    {
        key: 'horarios',
        icon: Clock,
        title: 'Horários',
        description: 'Defina os intervalos de atendimento por dia.',
    },
    {
        key: 'administrativo',
        icon: Shield,
        title: 'Administrativo',
        description: 'Permissões e regras de confirmação.',
        adminOnly: true,
    },
];
